import { useContext, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { Button, Input, Spinner } from '@fluentui/react-components';

const serverUrl = 'https://teams-app.getapeptalk.com/links';

const isValidEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};

const errorMessages = {
  invalidPattern: 'Invalid email address',
  loginFailed: (
    <>
      Login failed. Please try again or get in touch with the PepTalk team at{' '}
      <a style={{ color: '#fff' }} href="mailto:contact@peptalk.cc">
        contact@peptalk.cc
      </a>
    </>
  ),
};

export const LoginForm = ({ onError, isError }) => {
  const [emailVal, setEmailVal] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { setIsAuthenticated } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(emailVal)) {
      return onError({ isError: true, message: errorMessages.invalidPattern });
    }

    if (isError) onError({ isError: false });

    setIsLoading(true);

    const loginSuccess = await login(emailVal);

    if (!loginSuccess) {
      setIsLoading(false);
      return onError({ isError: true, message: errorMessages.loginFailed });
    }
  };

  const handleChange = (event) => {
    if (isError) onError({ isError: false });
    setEmailVal(event.target.value);
  };

  const login = async (email) => {
    const res = await axios.post(`${serverUrl}login/${email}`);
    if (res.data?.code === '404') return false;

    setIsAuthenticated(true);
    window.localStorage.setItem('email', email);
    return true;
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Input
        id="peptalk-email"
        name="peptalk-email"
        type="text"
        placeholder="email@example.com"
        value={emailVal}
        onChange={handleChange}
        required
        style={{ width: '100%', marginTop: 5, marginBottom: 5 }}
        disabled={isLoading}
      />
      <p style={{ textAlign: 'center' }}>
        If you don’t yet have a <b style={{ color: 'darkgrey' }}>PepTalk</b>{' '}
        account, please{' '}
        <a
          style={{ color: '#fff' }}
          href="https://login.getapeptalk.com/register"
        >
          sign up
        </a>
      </p>
      <Button
        appearance="outline"
        size="medium"
        disabled={isLoading}
        onClick={handleSubmit}
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        Continue
      </Button>
      {isLoading && (
        <div
          style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}
        >
          <Spinner />
        </div>
      )}
    </form>
  );
};
